import type { ExternalCalendarEvent } from '../../types';

export const isExternalCalendarEvent = (entity: any): entity is ExternalCalendarEvent =>
	entity.__typename === 'ExternalCalendarEvent';

export const getExternalCalendarEventLink = (event: ExternalCalendarEvent): string | null =>
	event?.url ?? null;
